//Stores
import * as UserStore from './User';
import * as ArInfo from './BillTo';
import * as ARModel from '../models/BillToModel';
import * as Session from './Session';
import * as Widgets from './Widget';
import * as History from './CallHistory';
import * as Equipment from './Equipment';
import * as CreditCard from './CreditCard';
import * as CreditCardFS from './CreditCardFS';
import * as ARInvoiceStore from './ARInvoice';
import * as ServiceContract from './ServiceContract';
import * as ServiceContractRenew from './ServiceContractRenew';
import * as ServiceContractRenewCharge from './ServiceContractRenewCharge';
import * as ServiceContractMaintSchedule from './ServiceContractMaintSchedule';
import * as ServiceContactStore from './ServiceContact';
import * as ServiceContactEntryStore from './ServiceContactEntry';
import * as CustomerRequestStore from './CustomerRequest';
import * as CustomerRequestListStore from './CustomerRequestList';
import * as CustomerRequestInitialData from './CustomerRequestInitialData';
import * as PendingAppointmentStore from './PendingAppointment';
import * as CustomerFeedbackStore from './CustomerFeedback';
import * as CustomerFeedbackListStore from './CustomerFeedbackList';
import * as AdditionalUserListStore from './AdditionalUserList';
import * as AdditionalUserStore from './AdditionalUser';
import * as AzureDocumentStore from './AzureDocuments';
//Models
import * as ARInvoiceModel from '../models/ArInvoiceModel';
import { SessionModel } from '../models/SessionModel';
import * as CreditCardMdl from '../models/CreditCardModel';
import * as CreditCardFSMdl from '../models/CreditCardModelFS';
import { RecommendationList } from '../store/Recommendation/recommendation';
import * as Recommendation from './Recommendation/recommendation';
import * as ServiceContractRenewMdl from '../models/ServiceContractRenewViewModel';
import * as ServiceContractRenewChargeMdl from '../models/ServiceContractRenewChargeViewModel';
import * as ServiceContractMaintScheduleMdls from '../models/ServiceContractMaintScheduleModel';
import * as ServiceContactMdls from '../models/ServiceContactModel';
import * as CustomerRequestMdls from '../models/CustomerRequestBucket';
import * as CustomerRequestListMdls from '../models/CustomerRequestBucketList';
import * as CustomerRequestInitialDataMdls from '../models/CustomerRequestInitialData';
import CustomerRequestList from '../components/CustomerRequestList/CustomerRequestList';
import * as PendingAppointmentMdls from '../models/PendingAppointmentModel';
import PendingAppointment from '../components/PendingAppointment/PendingAppointment';
import * as CustomerFeedbackMdls from '../models/CustomerFeedbackModel';
import * as AdditionalUserMdls from '../models/AdditionalUser';
import * as AzureDocumentMdls from '../models/AzureDocumentModel';


// The top-level state object
export interface ApplicationState {   
    sessionState: SessionModel,
    user: UserStore.UserState,
    billToList: ARModel.BillToList,
    widgetListState: Widgets.WidgetList,
    callHistoryState: History.CallHistoryList,
    equipmentState: Equipment.EquipmentList,
    serviceContractState: ServiceContract.ServiceContractList,  
    serviceContractMaintScheduleState: ServiceContractMaintScheduleMdls.ServiceContractMaintScheduleList,
    serviceContractRenewInfoState: ServiceContractRenewMdl.ServiceContractRenewViewModel,
    serviceContractRenewChargeCardState: ServiceContractRenewChargeMdl.ServiceContractRenewChargeScreenStatus,
    openInvoicesState: ARInvoiceModel.ArInvoiceModelList,
    //paidInvoicesState: ARInvoiceModel.ArInvoiceModelList,
    chargeCreditCardState: CreditCardMdl.CreditCardProcess,
    chargeCreditCardFSState: CreditCardFSMdl.CreditCardFSProcess,
    recommendationState: RecommendationList,
    serviceContactState: ServiceContactMdls.ServiceContactList,
    serviceContactEntryState: ServiceContactMdls.ServiceContactModel,
    customerRequestState: CustomerRequestMdls.CustomerRequestBucketModel,
    customerRequestListState: CustomerRequestListMdls.CustomerRequestBucketListModel,
    pendingAppointmentState: PendingAppointmentMdls.PendingAppointmentList
    customerFeedbackState: CustomerFeedbackMdls.CustomerFeedbackModel,
    customerFeedbackListState: CustomerFeedbackMdls.CustomerFeedbackListModel,
    customerRequestInitialDataState: CustomerRequestInitialDataMdls.CustomerRequestInitialData,
    additionalUserListState: AdditionalUserMdls.AdditionalUserList,
    additionalUserState: AdditionalUserMdls.AdditionalUser,
    azureDocumentsState: AzureDocumentMdls.AzureDocumentList
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers  = {
    //counter: Counter.reducer,
    //weatherForecasts: WeatherForecasts.reducer,
    //test: Test.reducer,
    user: UserStore.reducer,
    billToList: ArInfo.reducer,
    sessionState: Session.reducer,
    widgetListState: Widgets.reducer,
    callHistoryState: History.reducer,
    equipmentState: Equipment.reducer,    
    serviceContractState: ServiceContract.reducer,
    serviceContractMaintScheduleState: ServiceContractMaintSchedule.reducer,
    openInvoicesState: ARInvoiceStore.reducer, 
   // paidInvoicesState: ARInvoiceStore.reducer, 
    chargeCreditCardState: CreditCard.reducer,
    chargeCreditCardFSState: CreditCardFS.reducer,
    recommendationState: Recommendation.reducer,    
    serviceContractRenewInfoState: ServiceContractRenew.reducer,
    serviceContractRenewChargeCardState: ServiceContractRenewCharge.reducer,
    serviceContactState: ServiceContactStore.reducer,
    serviceContactEntryState: ServiceContactEntryStore.reducer,
    customerRequestState: CustomerRequestStore.reducer,
    customerRequestListState: CustomerRequestListStore.reducer,
    pendingAppointmentState: PendingAppointmentStore.reducer,
    customerFeedbackState: CustomerFeedbackStore.reducer,
    customerFeedbackListState: CustomerFeedbackListStore.reducer,
    customerRequestInitialDataState: CustomerRequestInitialData.reducer,
    additionalUserListState: AdditionalUserListStore.reducer,
    additionalUserState: AdditionalUserStore.reducer,
    azureDocumentsState: AzureDocumentStore.reducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
